import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

function Footer() {
  const { t } = useTranslation();

  const socialLinks = [
    {
      href: 'https://www.instagram.com/green_maker_lab/?igsh=OWJydmpjcWg3eTBp',
      icon: '/img/insta.svg',
      label: 'Instagram',
    },
    {
      href: 'https://youtube.com/@greenmakerlab?si=kV6nSefRa9THFY5n',
      icon: '/img/yt.svg',
      label: 'YouTube',
    },
  ];

  return (
    <footer className="relative mt-auto">
      {/* Gradient line */}
      <div className="h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />

      <div className="bg-surface border-t border-glass-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Left - Social Links */}
            <div className="flex items-center gap-4">
              <span className="text-text-secondary text-sm">{t('footer.followUs')}</span>
              <div className="flex gap-3">
                {socialLinks.map((link, index) => (
                  <motion.a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="p-2 bg-glass border border-glass-border rounded-lg hover:border-primary/40 hover:shadow-glow transition-all duration-300"
                  >
                    <img
                      src={link.icon}
                      alt={link.label}
                      className="w-5 h-5 opacity-70 hover:opacity-100 transition-opacity"
                    />
                  </motion.a>
                ))}
              </div>
            </div>

            {/* Center - Copyright */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-text-muted text-sm text-center"
            >
              <a 
                className="relative pb-1 text-text-muted hover:text-primary transition-colors duration-300 after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full" 
                href="https://github.com/jeffin872"
                target="_blank"
                rel="noopener noreferrer">
                {t('footer.developed')}
              </a>
            </motion.p>

            {/*  CNPQ  */}
            <motion.a
              href="https://dgp.cnpq.br/dgp/espelhogrupo/2028798278924905"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-primary/20 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <img
                src="/img/cnpq.jpg"
                alt="Certificado CNPQ"
                className="relative w-20 h-20 md:w-24 md:h-24 rounded-full border-2 border-glass-border group-hover:border-primary/40 transition-all duration-300"
              />
            </motion.a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
